import { createContext, useContext, useEffect, useState, useRef } from "react"
import { useUser } from "../../Contexts/UserContext/UserContext"
import { io } from "socket.io-client"

const SocketContext = createContext()

export const useSocket = () => useContext(SocketContext)

export default function SocketProvider({ children }) {
  const { context_user } = useUser()
  const [socket, setSocket] = useState(null)
  const socketRef = useRef(null)

  // יצירת Socket פעם אחת בלבד
  useEffect(() => {
    if (!context_user?._id) return // מחכים שהמשתמש יהיה זמין
    if (socketRef.current) return // כבר נוצר

    const s = io("wss://sharie-mfgc.onrender.com", {
      transports: ["websocket", "polling"], // שילוב שימנע בעיות חיבור
      reconnection: true,
      reconnectionAttempts: 5,
      withCredentials: true,
      extraHeaders: { "my-header": "optional" },
      query: { user: JSON.stringify({ id: context_user._id, name: context_user.user_name }) },
    })

    console.log(s)

    socketRef.current = s
    setSocket(s)

    s.on("connect", () => {
      console.log("Socket connected:", s.id)
    })

    s.on("disconnect", () => {
      console.log("Socket disconnected")
    })

    return () => {
      s.disconnect()
      console.log("Socket disconnected on cleanup")
    }
  }, [context_user?._id])

  // Emit join ברגע ש-context_user זמין
  useEffect(() => {
    if (socket && context_user?._id) {
      socket.emit("join", context_user._id)
      console.log("Joined room with user ID:", context_user._id)
    }
  }, [socket, context_user?._id])

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
}
